export function tokenChange(tokens) {
  return {
    type: "NAVIGATION_TOKEN_CHANGE",
    payload: { tokens }
  };
}
